module.exports = __webpack_public_path__ + "static/fox-sprite-2-e998f22f823034444b18b3f2109e1e00.png";